<div class="p-inputgroup">
    <p-chips
        id="positionChips"
        [(ngModel)]="positionPicker"
        [ngModelOptions]="{ standalone: true }"
        [max]="8"
        [allowDuplicate]="false"
        [disabled]="disabled"
        (onRemove)="onRemove()"
        class="hvl-entity-picker-chips"
        styleClass="hvl-entity-picker-chips-override"
        field="longText"
    >
        <ng-template let-item pTemplate="item" *ngIf="showCountOnly">
            {{ 'hrPerOrganizationGeneralInfo.positionSelectedText' | translate:{ count: positionPicker.length } }}
        </ng-template>
        <ng-template let-item pTemplate="item" *ngIf="!showCountOnly">
            {{item.objectCode ? item.objectCode  +" - "+item.longText:item.longText  }}
        </ng-template>
    </p-chips>

    <button (click)="onShow()" [disabled]="disabled" id="positionPickerButton" label=" " class="btn-icon-only hvl-entity-picker-search-button" pButton type="button">
        <i aria-hidden="true" class="material-icons">search</i>
    </button>
</div>
